import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useAPI from "../hooks/useAPI";
import useUser from "../hooks/useUser";
import Layout from "../components/Layout";

export const PrivateContent = (props) => {
  const { user } = useUser();

  if (user) {
    return (
      <>
        <Layout {...props} />
      </>
    );
  } else {
    return <h1>loading...</h1>;
  }
};

const useAuth = () => {
  const history = useHistory();
  const api = useAPI();
  const { user, setUser } = useUser();

  useEffect(() => {
    setTimeout(() => {
      if (!user) {
        api
          .get("/authentication/whoami")
          .then((res) => {
            setUser(res.data.user);
          })
          .catch((err) => {
            switch (err.response?.status) {
              default:
                history.push("/");
            }
          });
      }
    }, 1000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { PrivateContent };
};

export default useAuth;
